import {IPropertyTypeData, IPropertyTypeEnabledRuleContext} from '@toolify/client/src/modules/databases/types/IPropertyTypeData'
import {DatabasePropertyType} from 'toolify-server/src/models/mongoose/DatabasePropertyModel/enum/DatabasePropertyType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {ParticularColorType} from '@toolify/server/src/services/ColorService/enum/ParticularColorType'
import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'
import {ExperimentalFeatureFlagType} from '@toolify/server/src/models/mongoose/UserModel/enum/ExperimentalFeatureFlagType'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'

const palette = (payload: number): IParticularColor => ({
  colorType: ParticularColorType.Palette,
  payload,
})

export const PropertyTypeDataMap = new Map<
  DatabasePropertyType,
  IPropertyTypeData
>([
  [
    DatabasePropertyType.AutoId,
    {
      iconNameType: IconNameType.SortNumericDown,
      titleKey: 'database.properties.autoID',
      descriptionKey: 'database.properties.autoIDDescription',
      tagsKey: 'database.properties.autoIDTags',
      iconParticularColor: palette(39),
    },
  ],
  [
    DatabasePropertyType.RandomId,
    {
      iconNameType: IconNameType.Qrcode,
      titleKey: 'database.properties.randomId',
      descriptionKey: 'database.properties.randomIdDescription',
      tagsKey: 'database.properties.randomIdTags',
      iconParticularColor: palette(39),
    },
  ],
  [
    DatabasePropertyType.Text,
    {
      iconNameType: IconNameType.Text,
      titleKey: 'database.properties.text',
      descriptionKey: 'database.properties.textDescription',
      tagsKey: 'database.properties.textTags',
      iconParticularColor: palette(39),
    },
  ],
  [
    DatabasePropertyType.Markdown,
    {
      iconNameType: IconNameType.AlignLeft,
      titleKey: 'database.properties.markdown',
      descriptionKey: 'database.properties.markdownDescription',
      tagsKey: 'database.properties.markdownTags',
      iconParticularColor: palette(39),
    },
  ],
  [
    DatabasePropertyType.Number,
    {
      iconNameType: IconNameType.FaCircle1,
      titleKey: 'database.properties.number',
      descriptionKey: 'database.properties.numberDescription',
      tagsKey: 'database.properties.numberTags',
      iconParticularColor: palette(39),
    },
  ],
  [
    DatabasePropertyType.Boolean,
    {
      iconNameType: IconNameType.SquareCheck,
      titleKey: 'database.properties.boolean',
      descriptionKey: 'database.properties.booleanDescription',
      tagsKey: 'database.properties.booleanTags',
      iconParticularColor: palette(39),
    },
  ],

  [
    DatabasePropertyType.Date,
    {
      iconNameType: IconNameType.CalendarDays,
      titleKey: 'database.properties.date',
      descriptionKey: 'database.properties.dateDescription',
      tagsKey: 'database.properties.dateTags',
      iconParticularColor: palette(24),
    },
  ],
  [
    DatabasePropertyType.People,
    {
      iconNameType: IconNameType.UserVneck,
      titleKey: 'database.properties.people',
      descriptionKey: 'database.properties.peopleDescription',
      tagsKey: 'database.properties.peopleTags',
      iconParticularColor: palette(25),
    },
  ],
  [
    DatabasePropertyType.Rating,
    {
      iconNameType: IconNameType.Star,
      titleKey: 'database.properties.rating',
      descriptionKey: 'database.properties.ratingDescription',
      tagsKey: 'database.properties.ratingTags',
      iconParticularColor: palette(19),
    },
  ],
  [
    DatabasePropertyType.Comments,
    {
      iconNameType: IconNameType.CommentMiddle,
      titleKey: 'database.properties.comments',
      descriptionKey: 'database.properties.commentsDescription',
      tagsKey: 'database.properties.commentsTags',
      iconParticularColor: palette(17),
    },
  ],
  [
    DatabasePropertyType.Files,
    {
      iconNameType: IconNameType.File,
      titleKey: 'database.properties.files',
      descriptionKey: 'database.properties.filesDescription',
      tagsKey: 'database.properties.filesTags',
      iconParticularColor: palette(15),
    },
  ],
  [
    DatabasePropertyType.Status,
    {
      iconNameType: IconNameType.ClipboardCheck,
      titleKey: 'database.properties.status',
      descriptionKey: 'database.properties.statusDescription',
      tagsKey: 'database.properties.statusTags',
      iconParticularColor: palette(18),
    },
  ],
  [
    DatabasePropertyType.Dropdown,
    {
      iconNameType: IconNameType.Tags,
      titleKey: 'database.properties.dropdown',
      descriptionKey: 'database.properties.labelsDescription',
      tagsKey: 'database.properties.dropdownTags',
      iconParticularColor: palette(23),
    },
  ],
  [
    DatabasePropertyType.Phone,
    {
      iconNameType: IconNameType.Phone,
      titleKey: 'database.properties.phone',
      descriptionKey: 'database.properties.phoneDescription',
      tagsKey: 'database.properties.phoneTags',
      iconParticularColor: palette(25),
    },
  ],
  [
    DatabasePropertyType.Mail,
    {
      iconNameType: IconNameType.At,
      titleKey: 'database.properties.mail',
      descriptionKey: 'database.properties.mailDescription',
      tagsKey: 'database.properties.mailTags',
      iconParticularColor: palette(25),
    },
  ],
  [
    DatabasePropertyType.Location,
    {
      iconNameType: IconNameType.MapMarkerAlt,
      titleKey: 'database.properties.location',
      descriptionKey: 'database.properties.locationDescription',
      tagsKey: 'database.properties.locationTags',
      iconParticularColor: palette(25),
    },
  ],
  [
    DatabasePropertyType.Link,
    {
      iconNameType: IconNameType.ArrowUpRightFromSquare,
      titleKey: 'database.properties.link',
      descriptionKey: 'database.properties.linkDescription',
      tagsKey: 'database.properties.linkTags',
      iconParticularColor: palette(18),
    },
  ],
  [
    DatabasePropertyType.Relation,
    {
      iconNameType: IconNameType.LinkSimple,
      titleKey: 'database.properties.relation',
      descriptionKey: 'database.properties.relationDescription',
      tagsKey: 'database.properties.relationTags',
      iconParticularColor: palette(16),
    },
  ],
  [
    DatabasePropertyType.ReverseRelation,
    {
      iconNameType: IconNameType.Link,
      titleKey: 'database.properties.reverseRelation',
      descriptionKey: 'database.properties.reverseRelationDescription',
      tagsKey: 'database.properties.reverseRelationTags',
      iconParticularColor: palette(17),
    },
  ],
  [
    DatabasePropertyType.Teleport,
    {
      iconNameType: IconNameType.WandMagicSparkles,
      titleKey: 'database.properties.teleport',
      descriptionKey: 'database.properties.teleportDescription',
      tagsKey: 'database.properties.teleportTags',
      iconParticularColor: palette(14),
    },
  ],
  [
    DatabasePropertyType.Formula,
    {
      iconNameType: IconNameType.Calculator,
      titleKey: 'database.properties.formula',
      descriptionKey: 'database.properties.formulaDescription',
      tagsKey: 'database.properties.formulaTags',
      iconParticularColor: palette(24),
    },
  ],
  [
    DatabasePropertyType.TimeTracker,
    {
      iconNameType: IconNameType.Stopwatch,
      titleKey: 'database.properties.timeTracker',
      descriptionKey: 'database.properties.timeTrackerDescription',
      tagsKey: 'database.properties.timeTrackerTags',
      iconParticularColor: palette(20),
    },
  ],
  [
    DatabasePropertyType.CreatedAt,
    {
      iconNameType: IconNameType.CalendarPlus,
      titleKey: 'database.properties.createdAt',
      descriptionKey: 'database.properties.createdAtDescription',
      tagsKey: 'database.properties.createdAtTags',
      iconParticularColor: palette(23),
    },
  ],
  [
    DatabasePropertyType.UpdatedAt,
    {
      iconNameType: IconNameType.CalendarPen,
      titleKey: 'database.properties.updatedAt',
      descriptionKey: 'database.properties.updatedAtDescription',
      tagsKey: 'database.properties.updatedAtTags',
      iconParticularColor: palette(28),
    },
  ],

  [
    DatabasePropertyType.Checklist,
    {
      iconNameType: IconNameType.List,
      titleKey: 'database.properties.checklist',
      descriptionKey: 'database.properties.checklistDescription',
      tagsKey: 'database.properties.checklistTags',
      iconParticularColor: palette(25),
    },
  ],
  [
    DatabasePropertyType.Vote,
    {
      iconNameType: IconNameType.ThumbsUp,
      titleKey: 'database.properties.vote',
      descriptionKey: 'database.properties.voteDescription',
      tagsKey: 'database.properties.voteTags',
      iconParticularColor: palette(14),
    },
  ],
  [
    DatabasePropertyType.Button,
    {
      iconNameType: IconNameType.Bolt,
      titleKey: 'database.properties.button',
      descriptionKey: 'database.properties.buttonDescription',
      tagsKey: 'database.properties.buttonTags',
      iconParticularColor: palette(20),
      isEnabledRule: context => context.isExperimentalFeatureFlagEnabled(ExperimentalFeatureFlagType.EnableButtonProperty),
    },
  ],
  [
    DatabasePropertyType.Watchers,
    {
      iconNameType: IconNameType.Eye,
      titleKey: 'database.properties.watchers',
      descriptionKey: 'database.properties.watchersDescription',
      tagsKey: 'database.properties.watchersTags',
      iconParticularColor: palette(25),
      isEnabledRule: context => context.isExperimentalFeatureFlagEnabled(ExperimentalFeatureFlagType.EnableWatchersProperty),
    },
  ],
])

export const PropertyTypeByValueTypeMap = new Map<PropertyValueType, DatabasePropertyType>([
  [PropertyValueType.AutoId, DatabasePropertyType.AutoId],
  [PropertyValueType.Text, DatabasePropertyType.Text],
  [PropertyValueType.Markdown, DatabasePropertyType.Markdown],
  [PropertyValueType.Number, DatabasePropertyType.Number],
  [PropertyValueType.Boolean, DatabasePropertyType.Boolean],
  [PropertyValueType.Checkbox, DatabasePropertyType.Boolean],
  [PropertyValueType.Date, DatabasePropertyType.Date],
  [PropertyValueType.Person, DatabasePropertyType.People],
  [PropertyValueType.People, DatabasePropertyType.People],
  [PropertyValueType.Rating, DatabasePropertyType.Rating],
  [PropertyValueType.Comments, DatabasePropertyType.Comments],
  [PropertyValueType.File, DatabasePropertyType.Files],
  [PropertyValueType.Status, DatabasePropertyType.Status],
  [PropertyValueType.Dropdown, DatabasePropertyType.Dropdown],
  [PropertyValueType.Phone, DatabasePropertyType.Phone],
  [PropertyValueType.Mail, DatabasePropertyType.Mail],
  [PropertyValueType.Location, DatabasePropertyType.Location],
  [PropertyValueType.Link, DatabasePropertyType.Link],
  [PropertyValueType.Relation, DatabasePropertyType.Relation],
  [PropertyValueType.ReverseRelation, DatabasePropertyType.ReverseRelation],
  [PropertyValueType.Formula, DatabasePropertyType.Formula],
  [PropertyValueType.TimeTracker, DatabasePropertyType.TimeTracker],
  [PropertyValueType.CreatedAt, DatabasePropertyType.CreatedAt],
  [PropertyValueType.UpdatedAt, DatabasePropertyType.UpdatedAt],
  [PropertyValueType.Checklist, DatabasePropertyType.Checklist],
  [PropertyValueType.Vote, DatabasePropertyType.Vote],
  [PropertyValueType.Watchers, DatabasePropertyType.Watchers],
])

export function isPropertyTypeEnabled(
  databasePropertyType: DatabasePropertyType,
  context: IPropertyTypeEnabledRuleContext,
): boolean {
  const isEnabledRule = PropertyTypeDataMap.get(databasePropertyType)?.isEnabledRule
  return !isEnabledRule || isEnabledRule(context)
}
